// src/store/index.js

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import formConfig from './slices/formconfig';
import pendingRequestsSlice from './slices/pendingRequests';


// 1. Create the persist config
const persistConfig = {
  key: 'root', 
  storage, 

};

// 2. Combine your reducers
const rootReducer = combineReducers({
  formConfig: formConfig,
  requests: pendingRequestsSlice,
 
});

// 3. Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. Configure the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  // Add middleware to avoid serialization issues
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disables the serializable check for redux-persist actions
    }),
});

// 5. Create a persistor
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;